import { QuestionRoomCapacity } from "@/components/features/items/edit/room/_shared/ui/_components/capacity/capacity";

import { useDummyRoomCapacity } from "./hooks";

export const QuestionDummyRoomCapacity = () => {
	const {
		isEdited,
		hasError,
		capacityPeopleMaximum,
		onSetCapacityPeopleMaximum, //
		capacityAdultMaximum,
		onSetCapacityAdultMaximum,
		capacityKidsMaximum,
		onSetCapacityKidsMaximum,
		isKidsUnavailable,
		onSetIsKidsUnavailable,
	} = useDummyRoomCapacity();

	return (
		<QuestionRoomCapacity
			isEdited={isEdited}
			hasError={hasError}
			capacityPeopleMaximum={capacityPeopleMaximum}
			onSetCapacityPeopleMaximum={onSetCapacityPeopleMaximum}
			capacityAdultMaximum={capacityAdultMaximum}
			onSetCapacityAdultMaximum={onSetCapacityAdultMaximum}
			capacityKidsMaximum={capacityKidsMaximum}
			onSetCapacityKidsMaximum={onSetCapacityKidsMaximum}
			isKidsUnavailable={isKidsUnavailable}
			onSetIsKidsUnavailable={onSetIsKidsUnavailable}
		/>
	);
};

QuestionDummyRoomCapacity.displayName = "QuestionDummyRoomCapacity";
